/**
 * GTM Plugin - DESATIVADO TEMPORARIAMENTE
 *
 * O GTM está sendo carregado pela forma padrão do @nuxt/scripts via nuxt.config:
 *   scripts: { registry: { googleTagManager: true } }
 *   runtimeConfig.public.scripts.googleTagManager: { id: NUXT_GTM_ID }
 *
 * Para reativar o carregamento com delay (onNuxtReady + requestIdleCallback),
 * descomente o bloco abaixo e remova `registry: { googleTagManager: true }`
 * do nuxt.config.ts.
 */
export default defineNuxtPlugin(() => {
	// GTM carregado via scripts.registry no nuxt.config — plugin inativo.
	return;

	// --- Código original (descomente para reativar) ---
	// const config = useRuntimeConfig();
	// const gtmId = config.public.gtmId as string;
	// if (!gtmId || gtmId.trim() === '') return;
	// const idlePromise = new Promise<void>(resolve => {
	// 	onNuxtReady(() => {
	// 		if ('requestIdleCallback' in window) {
	// 			window.requestIdleCallback(() => resolve(), { timeout: 5000 });
	// 		} else {
	// 			setTimeout(() => resolve(), 2500);
	// 		}
	// 	});
	// });
	// useScriptGoogleTagManager({
	// 	id: gtmId,
	// 	scriptOptions: { trigger: idlePromise, warmupStrategy: false }
	// });
});
